export const configuration = {
    hostDev: 'http://localhost:8000',
    hostProd: 'https://server.8aevents.com/api',
    mainHost: 'https://www.8aevents.com',
    youtubeEndPoint: "/youtube/videos",
    loginEndPoint: "/auth",
    retrieveProjectsEndPoint: "/retrieve/projects",
    uploadImages: "/upload/file/portraits",
    local: false
}